import { Link } from 'react-router-dom';
import { ArrowRight, ArrowUpRight } from 'lucide-react';
import PageSEO from '../components/PageSEO';

export const ServicesPage = () => {
  const services = [
    {
      title: "Kentsel Dönüşüm",
      description: "Riskli yapıların güvenli, modern ve değerli yaşam alanlarına dönüştürülmesi. Hak sahipliği süreçlerinden anahtar teslime kadar kapsamlı çözümler.",
      details: ["Riskli yapı tespiti", "Hak sahipliği yönetimi", "Yeni yapı inşası", "Tapu ve iskan işlemleri"],
      image: "https://images.unsplash.com/photo-1532562145520-b8cce2486cd2?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1OTN8MHwxfHNlYXJjaHwxfHxwcmVtaXVtJTIwY29uc3RydWN0aW9uJTIwc2l0ZSUyMGFlcmlhbCUyMHZpZXclMjBtb2Rlcm58ZW58MHx8fHwxNzc1NDY1MDA5fDA&ixlib=rb-4.1.0&q=85",
    },
    {
      title: "İnşaat ve Taahhüt",
      description: "Anahtar teslim inşaat projeleri ve profesyonel taahhüt hizmetleri. En yüksek kalite standartlarında, zamanında teslimat garantisi.",
      details: ["Anahtar teslim projeler", "Kalite kontrol", "İş güvenliği", "Zamanında teslimat"],
      image: "https://images.unsplash.com/photo-1762758731316-419c3c283ed9?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTJ8MHwxfHNlYXJjaHwxfHx1cmJhbiUyMHJlbmV3YWwlMjB0cmFuc2Zvcm1hdGlvbiUyMG1vZGVybiUyMHJlc2lkZW50aWFsJTIwdG93ZXJ8ZW58MHx8fHwxNzc1NDY1MDY2fDA&ixlib=rb-4.1.0&q=85",
    },
    {
      title: "Proje Geliştirme",
      description: "Arsa değerlendirmeden projelendirmeye, inşaattan satışa kadar kapsamlı proje geliştirme hizmetleri.",
      details: ["Arsa değerlendirme", "Fizibilite analizi", "Proje planlama", "Satış stratejisi"],
      image: "https://images.unsplash.com/photo-1758548157747-285c7012db5b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDJ8MHwxfHNlYXJjaHwyfHxtb2Rlcm4lMjBhcGFydG1lbnQlMjBpbnRlcmlvciUyMGx1eHVyeSUyMGxpdmluZyUyMHJvb20lMjBkZXNpZ258ZW58MHx8fHwxNzc1NDY1MDA5fDA&ixlib=rb-4.1.0&q=85",
    },
    {
      title: "Mimari Tasarım",
      description: "Fonksiyonel, estetik ve sürdürülebilir mimari çözümler. Yaşam alanlarını insanların ihtiyaçlarına göre tasarlıyoruz.",
      details: ["Alan planlaması", "İç mimari", "Cephe tasarımı", "3D görselleştirme"],
      image: "https://images.unsplash.com/photo-1638454795595-0a0abf68614d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDJ8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjBhcGFydG1lbnQlMjBpbnRlcmlvciUyMGx1eHVyeSUyMGxpdmluZyUyMHJvb20lMjBkZXNpZ258ZW58MHx8fHwxNzc1NDY1MDA5fDA&ixlib=rb-4.1.0&q=85",
    },
  ];

  return (
    <div data-testid="services-page" className="page-transition">
      <PageSEO
        title="Hizmetlerimiz"
        description="VE PERA İnşaat hizmetleri — Kentsel dönüşüm, inşaat ve taahhüt, proje geliştirme ve mimari tasarım. Anahtar teslim çözümler."
        path="/hizmetler"
      />
      {/* Hero */}
      <section className="pt-32 lg:pt-40 pb-20 bg-[#f2f2f7]">
        <div className="container-wide">
          <div className="grid lg:grid-cols-12 gap-8">
            <div className="lg:col-span-7">
              <span className="overline mb-6 block">Hizmetlerimiz</span>
              <h1
                className="text-[clamp(2.5rem,6vw,4.5rem)] leading-[1] tracking-[-0.03em]"
                style={{ fontFamily: "var(--font-heading)", fontWeight: 400 }}
              >
                Uzmanlık
                <br />alanlarımız
              </h1>
            </div>
            <div className="lg:col-span-4 lg:col-start-9 flex items-end">
              <p 
                className="text-[#8e8e93] leading-[1.9] text-[15px]"
                style={{ fontFamily: "var(--font-body)" }}
              >
                İnşaat ve proje geliştirme alanında kapsamlı hizmetler. Her projede mühendislik mükemmelliği ve değer yaratma hedefi.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Services - Alternating layout */}
      {services.map((service, index) => (
        <section 
          key={index}
          data-testid={`service-${index}`}
          className={`${index % 2 === 0 ? 'bg-[#f2f2f7]' : 'bg-[#d1d1d6]/20'}`}
        >
          <div className={`grid lg:grid-cols-2 ${index % 2 === 1 ? 'lg:flex-row-reverse' : ''}`}>
            {/* Image */}
            <div className={`h-[50vh] lg:h-[80vh] ${index % 2 === 1 ? 'lg:order-2' : ''}`}>
              <img
                src={service.image}
                alt={service.title}
                className="w-full h-full object-cover"
              />
            </div>
            
            {/* Content */}
            <div className={`flex items-center p-8 lg:p-16 xl:p-24 ${index % 2 === 1 ? 'lg:order-1' : ''}`}>
              <div className="max-w-lg">
                <h2
                  className="text-[clamp(1.75rem,3vw,2.5rem)] leading-[1.15] tracking-[-0.02em] mb-6"
                  style={{ fontFamily: "var(--font-heading)", fontWeight: 400 }}
                >
                  {service.title}
                </h2>
                <p 
                  className="text-[#8e8e93] leading-[1.9] mb-8 text-[15px]"
                  style={{ fontFamily: "var(--font-body)" }}
                >
                  {service.description}
                </p>
                <ul className="space-y-3 mb-10">
                  {service.details.map((detail, idx) => (
                    <li 
                      key={idx}
                      className="flex items-center gap-4 text-[14px] text-[#8e8e93]"
                      style={{ fontFamily: "var(--font-body)" }}
                    >
                      <span className="w-1 h-1 bg-[#041f60]"></span>
                      {detail}
                    </li>
                  ))}
                </ul>
                <Link to="/iletisim" className="link-line text-[#1a1a1a] hover:text-[#041f60] transition-colors">
                  Detaylı Bilgi Alın
                </Link>
              </div>
            </div>
          </div>
        </section>
      ))}

      {/* CTA */}
      <section className="py-24 lg:py-32 bg-[#1a1a1a]">
        <div className="container-wide text-center">
          <h2
            className="text-[clamp(1.75rem,4vw,2.5rem)] leading-[1.15] tracking-[-0.02em] text-[#f2f2f7] mb-8"
            style={{ fontFamily: "var(--font-heading)", fontWeight: 400 }}
          >
            Size özel çözümler için görüşelim
          </h2>
          <p 
            className="text-[#d1d1d6]/70 text-[15px] mb-10 max-w-md mx-auto"
            style={{ fontFamily: "var(--font-body)" }}
          >
            İhtiyaçlarınıza uygun en doğru hizmet paketini birlikte belirleyelim.
          </p>
          <Link to="/iletisim" className="btn-hero-primary">
            Ücretsiz Danışmanlık
            <ArrowRight size={14} />
          </Link>
        </div>
      </section>
    </div>
  );
};

export default ServicesPage;
